export default __webpack_public_path__ + "static/media/005-gluten.0ad520a7.svg";